import * as React from 'react';

import * as styles from './PurchaseTermCallButtonWrapper.css';

export const PurchaseTermCallButtonWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['wrapper']}>{children}</div>;
};
